export const CONFIG_ACTION_TRANSLATIONS = "appTranslations";
export const CONFIG_ACTION_LANGUAGES = "appLanguages";
export const CONFIG_ACTION_CULTURE = "appCulture";

export const configReducer = (state, action) => {
  switch (action.type) {
    case CONFIG_ACTION_LANGUAGES:
      return {
        ...state,
        languages: action.payload,
      };
    case CONFIG_ACTION_TRANSLATIONS:
      return {
        ...state,
        translations: action.payload,
      };
    case CONFIG_ACTION_CULTURE:
      return {
        ...state,
        culture: action.payload,
      };
    default:
      return state;
  }
};
